// extracted by mini-css-extract-plugin
export default {"dateContainer":"A5_nrg","date":"vwuSKW","time":"RhnoN3","with-time":"Xtir5y"};